var _rect, _rect2, _rect3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOsPc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 0,
    x: 7,
    y: 12,
    width: 2,
    height: 3,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 0,
    x: 4,
    y: 14,
    width: 8,
    height: 1,
    rx: 0.5,
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 0,
    x: 1,
    y: 9,
    width: 14,
    height: 1,
    rx: 0.5,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1,
    d: "M1.5 4.18C1.5 3.62127 1.50038 3.23179 1.52476 2.92839C1.54868 2.63069 1.59329 2.45939 1.65818 2.32953C1.80337 2.03896 2.03896 1.80337 2.32953 1.65818C2.45939 1.59329 2.63069 1.54868 2.92839 1.52476C3.23179 1.50038 3.62127 1.5 4.18 1.5H11.82C12.3787 1.5 12.7682 1.50038 13.0716 1.52476C13.3693 1.54868 13.5406 1.59329 13.6705 1.65818C13.961 1.80337 14.1966 2.03896 14.3418 2.32953C14.4067 2.45939 14.4513 2.63069 14.4752 2.92839C14.4996 3.23179 14.5 3.62127 14.5 4.18V8.82C14.5 9.37873 14.4996 9.76821 14.4752 10.0716C14.4513 10.3693 14.4067 10.5406 14.3418 10.6705C14.1966 10.961 13.961 11.1966 13.6705 11.3418C13.5406 11.4067 13.3693 11.4513 13.0716 11.4752C12.7682 11.4996 12.3787 11.5 11.82 11.5H4.18C3.62127 11.5 3.23179 11.4996 2.92839 11.4752C2.63069 11.4513 2.45939 11.4067 2.32953 11.3418C2.03896 11.1966 1.80337 10.961 1.65818 10.6705L1.21091 10.894L1.65818 10.6705C1.59329 10.5406 1.54868 10.3693 1.52476 10.0716C1.50038 9.76821 1.5 9.37873 1.5 8.82V4.18Z",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOsPc);
export default __webpack_public_path__ + "static/media/os-pc.65d268035d59c37939321406ef59727e.svg";
export { ForwardRef as ReactComponent };